import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ICenterData } from "../../../models/admin/center/center,model";
import CenterService from "../../../services/admin/center.service";
import trainerRegistration from "../../../services/trainer/trainerRegistration";

export const EditCenterModal: React.FC<any> = ({
  isOpenEditcenter,
  onClosed,
  isEditcenter = false,
  reload,
  center,
}: {
  isEditcenter: boolean;
  isOpenEditcenter: any;
  onClosed: any;
  reload: any;
  center: ICenterData;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const navigate = useNavigate();
  const [trainingCenter, settrainingCenter] = useState(false);
  const [postingCenter, setpostingCenter] = useState(false);
  const [centerType, setType] = useState<any[]>([
    {
      type: "rtc",
      name: "RTC",
    },
    {
      type: "field",
      name: "Posting Center",
    },
    {
      type: "exam",
      name: "Exam Center",
    },
    {
      type: "other",
      name: "Other",
    },
  ]);
  const [statesList, setState] = useState<any[]>();
  const [lga, setLga] = useState<any[]>();
  useEffect(() => {
    trainerRegistration
      .getState(160)
      .then((res) => {
        setState(res.data.data);
        if (center && center.state_id) {
          getLga(center.state_id.toString());
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        formik.setValues({
          name: center.name,
          address: center.address,
          state_id: center.state_id ? `${center.state}:${center.state_id.toString()}` : "",
          phone: center.phone,
          email: center.email,
          lga: center.lga_id ?`${center.lga}:${center.lga_id.toString()}` : "",
          rtcType: center.category,
        });
      });
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.name) {
        errors.name = "Enter name";
      }
      if (!values.address) {
        errors.address = "enter address";
      }
      if (!values.state_id) {
        errors.state_id = "select state ";
      }
      return errors;
    },
    initialValues: {
      name: "",
      address: "",
      state_id: "",
      phone: "",
      email: "",
      lga: "",
      rtcType: "",
    },
    onSubmit: async (values) => {
      try {
        const new_param: any = {
          name: values.name,
          address: values.address,
          city: values.lga.split(":")[0],
          state_id: values.state_id.split(":")[1],
          lga_id: values.lga.split(":")[1],
          state: values.state_id.split(":")[0],
          lga: values.lga.split(":")[0],
          zipcode: "",
          phone: values.phone,
          email: values.email,
          category: values.rtcType,
        };

        const create_param: any = await CenterService.updateBadge(
          new_param,
          center.uuid
        );

        if (create_param) {
          toast({
            title: "center ",
            description: "center  updated successfully",
            status: "success",
          });
          onClosed(!isEditcenter);
          reload();
        } else {
          toast({
            title: "center ",
            description: `${create_param.message}`,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "center ",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  const getLga = (state_id: string) => {
    trainerRegistration.getLga(parseInt(state_id)).then((res) => {
      setLga(res.data.data);
    });
  };

  return (
    <>
      <Modal
        isOpen={isOpenEditcenter && isEditcenter}
        onClose={onClosed}
        scrollBehavior="outside"
        closeOnOverlayClick={true}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader>
            {
              <Text fontSize={"22px"} pb={3} textTransform="capitalize">
                Edit center
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody pb={"30px"}>
            <Box>
              <form onSubmit={formik.handleSubmit}>
                <HStack mb={"20px"}>
                  <FormControl
                    isInvalid={
                      formik.errors.name && formik.touched.name ? true : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Name
                    </FormLabel>
                    <Input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.name}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={
                      formik.errors.rtcType && formik.touched.rtcType
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Category
                    </FormLabel>
                    <Select
                      variant="outline"
                      size="md"
                      placeholder="Select category"
                      value={formik.values.rtcType}
                      name="rtcType"
                      onChange={formik.handleChange}
                      fontSize={12}
                    >
                      {centerType.map((each: any, index: number) => (
                        <option key={index} value={each.type}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.name}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>
                <HStack mb={"20px"}>
                  <FormControl
                    isInvalid={
                      formik.errors.state_id && formik.touched.state_id
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      State
                    </FormLabel>
                    <Select
                      variant="outline"
                      size="md"
                      placeholder="Select state"
                      value={formik.values.state_id}
                      name="state_id"
                      onChange={formik.handleChange}
                      fontSize={12}
                      onClick={(e: any) => {
                        if (e.target.value) getLga(e.target.value);
                      }}
                    >
                      {statesList &&
                        statesList.map((each: any, index: number) => (
                          <option key={index} value={`${each.name}:${each.id}`}>
                            {" "}
                            {each.name}{" "}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.name}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={
                      formik.errors.state_id && formik.touched.state_id
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      LGA
                    </FormLabel>
                    <Select
                      variant="outline"
                      size="md"
                      placeholder="Select LGA"
                      value={formik.values.lga}
                      name="lga"
                      onChange={formik.handleChange}
                      fontSize={12}
                    >
                      {lga &&
                        lga.map((each: any, index: number) => (
                          <option key={index} value={`${each.name}:${each.id}`}>
                            {" "}
                            {each.name}{" "}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.lga}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>
                <HStack mb={"20px"}>
                  <FormControl
                    isInvalid={
                      formik.errors.email && formik.touched.email ? true : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Email
                    </FormLabel>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={formik.values.email}
                      placeholder="Enter email"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.email}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    isInvalid={
                      formik.errors.name && formik.touched.name ? true : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Phone
                    </FormLabel>
                    <Input
                      type="number"
                      id="phone"
                      name="phone"
                      value={formik.values.phone}
                      placeholder="Enter phone"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.phone}
                    </FormErrorMessage>
                  </FormControl>
                </HStack>

                <FormControl
                  mt={3}
                  isInvalid={
                    formik.errors.address && formik.touched.address
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>
                    Address
                  </FormLabel>
                  <Input
                    type="text"
                    id="address"
                    name="address"
                    value={formik.values.address}
                    placeholder="Enter address"
                    onChange={formik.handleChange}
                    fontSize={13}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.address}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent={"space-between"}>
                  <Button
                    px={6}
                    colorScheme="red"
                    fontSize={"14px"}
                    variant={"outline"}
                    ref={cancelRef}
                    width={"49%"}
                    onClick={() => onClosed()}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    isLoading={formik.isSubmitting}
                    colorScheme="red"
                    width={"49%"}
                    px={6}
                    fontSize={"14px"}
                  >
                    Confirm
                  </Button>
                </Flex>
              </form>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
